import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import differenceBy from 'lodash.differenceby';

import CurrencySelect from 'components/commons/CurrencySelect';

import { OptionList, Option } from './styles';

export const CurrencyFilters = ({
  primaryOptions,
  onChange,
  value,
  optionsList,
}) => {
  const displayOptions = useMemo(() => {
    if (!value) {
      return primaryOptions;
    }
    if (primaryOptions.find(option => option.id === value)) {
      return primaryOptions;
    }
    const mainOptions = primaryOptions.slice(0, primaryOptions.length - 1);
    return [...mainOptions, { id: value }];
  }, [value, primaryOptions]);

  const dropdownOptions = useMemo(() => {
    return differenceBy(optionsList, primaryOptions, 'id').map(item => ({
      meta: item,
      value: item.id,
      label: item.name,
    }));
  }, [optionsList, primaryOptions]);

  return (
    <OptionList>
      {displayOptions.map(el => (
        <Option
          key={el.id}
          name={el.id}
          current={value}
          onClick={() => onChange(el.id)}
        >
          {el.id}
        </Option>
      ))}
      {dropdownOptions && optionsList && (
        <CurrencySelect
          options={dropdownOptions}
          isButtonMode
          onChange={onChange}
        />
      )}
    </OptionList>
  );
};

CurrencyFilters.propTypes = {
  primaryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  optionsList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
      text: PropTypes.string,
    })
  ),
};

CurrencyFilters.defaultProps = {
  optionsList: null,
  primaryOptions: [],
};
